module.exports = new __parcel__URL__("connect-warner-media_pos.101d0275.svg").toString();